module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_sugimoto-436810cc9c88add7fbf79d249dfb88cb.jpg";